module.exports = __webpack_public_path__ + "static/freshcity-logo-7ba679d9a0ec7872d332e2dd6b563355.png";